import { GetShopProductsQuery } from './getShopProducts';

type GetShopProductsQueryWrapper = {
  data: GetShopProductsQuery;
  extensions: {
    cost: {
      'shop-product-catalog': {
        maxQueryCost: number;
        requestedQueryCost: number;
        actualQueryCost: number;
      };
    };
  };
};

export default {
  data: {
    shopProductBySkuId: {
      id: 99,
      name: 'Kaylee Skinny Colored Jean',
      brand: {
        name: 'Liverpool',
        __typename: 'Brand',
      },
      businessLine: 'WOMENS',
      externalProductId: '2MNXW5R3R',
      defaultVariant: {
        sku: 2198904,
        url: 'https://www.stitchfix.com/product/Liverpool-Kaylee-Skinny-Colored-Jean/2MNXW5R3R?sku-id=2198904&color=Brown&size=24W&inseam=28',
        media: [
          {
            altText: 'figure_front',
            category: 'figure_front',
            group: 'figure_image',
            label: 'figure_front',
            contentType: 'IMAGE',
            modelSize: {
              alphaSizeName: '1X',
              dress: 16,
              height: 69,
              waist: null,
              __typename: 'MediaModel',
            },
            originalSrc:
              'https://d3n78nkjl8tizo.cloudfront.net/stitch-fix/image/upload/v1648044247/mx0capolu91qsbcycfdc.jpg',
            position: 0,
            __typename: 'ShopMedia',
          },
          {
            altText: 'figure_back',
            category: 'figure_back',
            group: 'figure_image',
            label: 'figure_back',
            contentType: 'IMAGE',
            modelSize: {
              alphaSizeName: '1X',
              dress: 16,
              height: 69,
              waist: null,
              __typename: 'MediaModel',
            },
            originalSrc:
              'https://d3n78nkjl8tizo.cloudfront.net/stitch-fix/image/upload/v1648044347/iru2lqxhhgxauvlnmqnv.jpg',
            position: 1,
            __typename: 'ShopMedia',
          },
          {
            altText: 'figure_left',
            category: 'figure_left',
            group: 'figure_image',
            label: 'figure_left',
            contentType: 'IMAGE',
            modelSize: {
              alphaSizeName: '1X',
              dress: 16,
              height: 69,
              waist: null,
              __typename: 'MediaModel',
            },
            originalSrc:
              'https://d3n78nkjl8tizo.cloudfront.net/stitch-fix/image/upload/v1648044297/ytwsxdwog1den1ah63kv.jpg',
            position: 2,
            __typename: 'ShopMedia',
          },
          {
            altText: 'figure_detail',
            category: 'figure_detail',
            group: 'figure_image',
            label: 'figure_detail',
            contentType: 'IMAGE',
            modelSize: {
              alphaSizeName: '1X',
              dress: 16,
              height: 69,
              waist: null,
              __typename: 'MediaModel',
            },
            originalSrc:
              'https://d3n78nkjl8tizo.cloudfront.net/stitch-fix/image/upload/v1648044389/mc4rpchuqcw3eqmmhvvu.jpg',
            position: 3,
            __typename: 'ShopMedia',
          },
          {
            altText: 'flat_front',
            category: 'flat_front',
            group: 'flat_image',
            label: 'flat_front',
            contentType: 'IMAGE',
            modelSize: null,
            originalSrc:
              'https://d3n78nkjl8tizo.cloudfront.net/stitch-fix/image/upload/v1637026641/v5karv9myyxno7gjfchh.jpg',
            position: 4,
            __typename: 'ShopMedia',
          },
          {
            altText: 'style_card',
            category: 'style_card',
            group: 'style_card',
            label: 'style_card',
            contentType: 'IMAGE',
            modelSize: null,
            originalSrc:
              'https://d3n78nkjl8tizo.cloudfront.net/stitch-fix/image/upload/v1637026709/kmgpjzyllxqkgnkfxe5e.jpg',
            position: 5,
            __typename: 'ShopMedia',
          },
        ],
        color: {
          uniqueColorId: 101438886,
          name: 'Brown',
          swatch: {
            hex: '#825b3a',
            url: null,
            __typename: 'ColorSwatch',
          },
          __typename: 'Color',
        },
        size: {
          name: '24W',
          __typename: 'Size',
        },
        inseam: {
          name: 28,
          __typename: 'Inseam',
        },
        detailGroups: [
          {
            key: 'materials_care',
            label: 'Materials & care',
            details: [
              {
                key: 'materials',
                label: 'Materials',
                value: '58% cotton, 32% lyocell, 8% polyester, 2% elastane',
                __typename: 'ProductDetail',
              },
              {
                key: 'item_care',
                label: 'Item care',
                value: 'Machine wash',
                __typename: 'ProductDetail',
              },
            ],
            __typename: 'ProductDetailGroup',
          },
          {
            key: 'product_details',
            label: 'Product details',
            details: [
              {
                key: 'print',
                label: 'Print',
                value: 'Solid',
                __typename: 'ProductDetail',
              },
              {
                key: 'cut',
                label: 'Cut',
                value: 'Skinny',
                __typename: 'ProductDetail',
              },
              {
                key: 'inseam',
                label: 'Inseam',
                value: '28",',
                __typename: 'ProductDetail',
              },
              {
                key: 'rise',
                label: 'Rise',
                value: 'High rise, 12",',
                __typename: 'ProductDetail',
              },
              {
                key: 'pockets',
                label: 'Pockets',
                value: 'Front, back',
                __typename: 'ProductDetail',
              },
              {
                key: 'stretch',
                label: 'Stretch',
                value: 'Has stretch',
                __typename: 'ProductDetail',
              },
            ],
            __typename: 'ProductDetailGroup',
          },
        ],
        __typename: 'ShopProductVariant',
      },
      productType: {
        family: 'Clothing',
        klass: 'Lower Body Wear/Bottoms',
        __typename: 'ProductClassification',
      },
      variantBySkuId: {
        sku: 2198902,
        url: 'https://www.stitchfix.com/product/Liverpool-Kaylee-Skinny-Colored-Jean/2MNXW5R3R?sku-id=2198902&color=Brown&size=20W&inseam=28',
        media: [
          {
            altText: 'figure_front',
            category: 'figure_front',
            group: 'figure_image',
            label: 'figure_front',
            contentType: 'IMAGE',
            modelSize: {
              alphaSizeName: '1X',
              dress: 16,
              height: 69,
              waist: null,
              __typename: 'MediaModel',
            },
            originalSrc:
              'https://d3n78nkjl8tizo.cloudfront.net/stitch-fix/image/upload/v1648044247/mx0capolu91qsbcycfdc.jpg',
            position: 0,
            __typename: 'ShopMedia',
          },
          {
            altText: 'figure_back',
            category: 'figure_back',
            group: 'figure_image',
            label: 'figure_back',
            contentType: 'IMAGE',
            modelSize: {
              alphaSizeName: '1X',
              dress: 16,
              height: 69,
              waist: null,
              __typename: 'MediaModel',
            },
            originalSrc:
              'https://d3n78nkjl8tizo.cloudfront.net/stitch-fix/image/upload/v1648044347/iru2lqxhhgxauvlnmqnv.jpg',
            position: 1,
            __typename: 'ShopMedia',
          },
          {
            altText: 'figure_left',
            category: 'figure_left',
            group: 'figure_image',
            label: 'figure_left',
            contentType: 'IMAGE',
            modelSize: {
              alphaSizeName: '1X',
              dress: 16,
              height: 69,
              waist: null,
              __typename: 'MediaModel',
            },
            originalSrc:
              'https://d3n78nkjl8tizo.cloudfront.net/stitch-fix/image/upload/v1648044297/ytwsxdwog1den1ah63kv.jpg',
            position: 2,
            __typename: 'ShopMedia',
          },
          {
            altText: 'figure_detail',
            category: 'figure_detail',
            group: 'figure_image',
            label: 'figure_detail',
            contentType: 'IMAGE',
            modelSize: {
              alphaSizeName: '1X',
              dress: 16,
              height: 69,
              waist: null,
              __typename: 'MediaModel',
            },
            originalSrc:
              'https://d3n78nkjl8tizo.cloudfront.net/stitch-fix/image/upload/v1648044389/mc4rpchuqcw3eqmmhvvu.jpg',
            position: 3,
            __typename: 'ShopMedia',
          },
          {
            altText: 'flat_front',
            category: 'flat_front',
            group: 'flat_image',
            label: 'flat_front',
            contentType: 'IMAGE',
            modelSize: null,
            originalSrc:
              'https://d3n78nkjl8tizo.cloudfront.net/stitch-fix/image/upload/v1637026641/v5karv9myyxno7gjfchh.jpg',
            position: 4,
            __typename: 'ShopMedia',
          },
          {
            altText: 'style_card',
            category: 'style_card',
            group: 'style_card',
            label: 'style_card',
            contentType: 'IMAGE',
            modelSize: null,
            originalSrc:
              'https://d3n78nkjl8tizo.cloudfront.net/stitch-fix/image/upload/v1637026709/kmgpjzyllxqkgnkfxe5e.jpg',
            position: 5,
            __typename: 'ShopMedia',
          },
        ],
        color: {
          uniqueColorId: 101438886,
          name: 'Brown',
          swatch: {
            hex: '#825b3a',
            url: null,
            __typename: 'ColorSwatch',
          },
          __typename: 'Color',
        },
        size: {
          name: '20W',
          __typename: 'Size',
        },
        inseam: {
          name: 28,
          __typename: 'Inseam',
        },
        detailGroups: [
          {
            key: 'materials_care',
            label: 'Materials & care',
            details: [
              {
                key: 'materials',
                label: 'Materials',
                value: '58% cotton, 32% lyocell, 8% polyester, 2% elastane',
                __typename: 'ProductDetail',
              },
              {
                key: 'item_care',
                label: 'Item care',
                value: 'Machine wash',
                __typename: 'ProductDetail',
              },
            ],
            __typename: 'ProductDetailGroup',
          },
          {
            key: 'product_details',
            label: 'Product details',
            details: [
              {
                key: 'print',
                label: 'Print',
                value: 'Solid',
                __typename: 'ProductDetail',
              },
              {
                key: 'cut',
                label: 'Cut',
                value: 'Skinny',
                __typename: 'ProductDetail',
              },
              {
                key: 'inseam',
                label: 'Inseam',
                value: '28",',
                __typename: 'ProductDetail',
              },
              {
                key: 'rise',
                label: 'Rise',
                value: 'High rise, 12",',
                __typename: 'ProductDetail',
              },
              {
                key: 'pockets',
                label: 'Pockets',
                value: 'Front, back',
                __typename: 'ProductDetail',
              },
              {
                key: 'stretch',
                label: 'Stretch',
                value: 'Has stretch',
                __typename: 'ProductDetail',
              },
            ],
            __typename: 'ProductDetailGroup',
          },
        ],
        __typename: 'ShopProductVariant',
      },
      __typename: 'ShopProduct',
    },
    shopProductByExternalProductId: {
      id: 99,
      name: 'Kaylee Skinny Colored Jean',
      brand: {
        name: 'Liverpool',
        __typename: 'Brand',
      },
      businessLine: 'WOMENS',
      externalProductId: '2MNXW5R3R',
      defaultVariant: {
        sku: 2198904,
        url: 'https://www.stitchfix.com/product/Liverpool-Kaylee-Skinny-Colored-Jean/2MNXW5R3R?sku-id=2198904&color=Brown&size=24W&inseam=28',
        media: [
          {
            altText: 'figure_front',
            category: 'figure_front',
            group: 'figure_image',
            label: 'figure_front',
            contentType: 'IMAGE',
            modelSize: {
              alphaSizeName: '1X',
              dress: 16,
              height: 69,
              waist: null,
              __typename: 'MediaModel',
            },
            originalSrc:
              'https://d3n78nkjl8tizo.cloudfront.net/stitch-fix/image/upload/v1648044247/mx0capolu91qsbcycfdc.jpg',
            position: 0,
            __typename: 'ShopMedia',
          },
          {
            altText: 'figure_back',
            category: 'figure_back',
            group: 'figure_image',
            label: 'figure_back',
            contentType: 'IMAGE',
            modelSize: {
              alphaSizeName: '1X',
              dress: 16,
              height: 69,
              waist: null,
              __typename: 'MediaModel',
            },
            originalSrc:
              'https://d3n78nkjl8tizo.cloudfront.net/stitch-fix/image/upload/v1648044347/iru2lqxhhgxauvlnmqnv.jpg',
            position: 1,
            __typename: 'ShopMedia',
          },
          {
            altText: 'figure_left',
            category: 'figure_left',
            group: 'figure_image',
            label: 'figure_left',
            contentType: 'IMAGE',
            modelSize: {
              alphaSizeName: '1X',
              dress: 16,
              height: 69,
              waist: null,
              __typename: 'MediaModel',
            },
            originalSrc:
              'https://d3n78nkjl8tizo.cloudfront.net/stitch-fix/image/upload/v1648044297/ytwsxdwog1den1ah63kv.jpg',
            position: 2,
            __typename: 'ShopMedia',
          },
          {
            altText: 'figure_detail',
            category: 'figure_detail',
            group: 'figure_image',
            label: 'figure_detail',
            contentType: 'IMAGE',
            modelSize: {
              alphaSizeName: '1X',
              dress: 16,
              height: 69,
              waist: null,
              __typename: 'MediaModel',
            },
            originalSrc:
              'https://d3n78nkjl8tizo.cloudfront.net/stitch-fix/image/upload/v1648044389/mc4rpchuqcw3eqmmhvvu.jpg',
            position: 3,
            __typename: 'ShopMedia',
          },
          {
            altText: 'flat_front',
            category: 'flat_front',
            group: 'flat_image',
            label: 'flat_front',
            contentType: 'IMAGE',
            modelSize: null,
            originalSrc:
              'https://d3n78nkjl8tizo.cloudfront.net/stitch-fix/image/upload/v1637026641/v5karv9myyxno7gjfchh.jpg',
            position: 4,
            __typename: 'ShopMedia',
          },
          {
            altText: 'style_card',
            category: 'style_card',
            group: 'style_card',
            label: 'style_card',
            contentType: 'IMAGE',
            modelSize: null,
            originalSrc:
              'https://d3n78nkjl8tizo.cloudfront.net/stitch-fix/image/upload/v1637026709/kmgpjzyllxqkgnkfxe5e.jpg',
            position: 5,
            __typename: 'ShopMedia',
          },
        ],
        color: {
          uniqueColorId: 101438886,
          name: 'Brown',
          swatch: {
            hex: '#825b3a',
            url: null,
            __typename: 'ColorSwatch',
          },
          __typename: 'Color',
        },
        size: {
          name: '24W',
          __typename: 'Size',
        },
        inseam: {
          name: 28,
          __typename: 'Inseam',
        },
        detailGroups: [
          {
            key: 'materials_care',
            label: 'Materials & care',
            details: [
              {
                key: 'materials',
                label: 'Materials',
                value: '58% cotton, 32% lyocell, 8% polyester, 2% elastane',
                __typename: 'ProductDetail',
              },
              {
                key: 'item_care',
                label: 'Item care',
                value: 'Machine wash',
                __typename: 'ProductDetail',
              },
            ],
            __typename: 'ProductDetailGroup',
          },
          {
            key: 'product_details',
            label: 'Product details',
            details: [
              {
                key: 'print',
                label: 'Print',
                value: 'Solid',
                __typename: 'ProductDetail',
              },
              {
                key: 'cut',
                label: 'Cut',
                value: 'Skinny',
                __typename: 'ProductDetail',
              },
              {
                key: 'inseam',
                label: 'Inseam',
                value: '28"',
                __typename: 'ProductDetail',
              },
              {
                key: 'rise',
                label: 'Rise',
                value: 'High rise, 12"',
                __typename: 'ProductDetail',
              },
              {
                key: 'pockets',
                label: 'Pockets',
                value: 'Front, back',
                __typename: 'ProductDetail',
              },
              {
                key: 'stretch',
                label: 'Stretch',
                value: 'Has stretch',
                __typename: 'ProductDetail',
              },
            ],
            __typename: 'ProductDetailGroup',
          },
        ],
        __typename: 'ShopProductVariant',
      },
      productType: {
        family: 'Clothing',
        klass: 'Lower Body Wear/Bottoms',
        __typename: 'ProductClassification',
      },
      __typename: 'ShopProduct',
    },
  },
} as unknown as GetShopProductsQueryWrapper;
